import React from "react";
import { useSelector } from "react-redux";
import { ModalLayout } from "@strapi/design-system/ModalLayout";
import { DialogTitle } from "./DialogTitle";
import WidenSearchBox from "../WidenSearchBox";
import styles from "./WidenLibrary.module.css";
export const WidenModal = ({
  onSelect,
  filter,
  onClose
}) => {
  const {
    showWidenModal
  } = useSelector(state => state.widenSearch);
  return /*#__PURE__*/React.createElement(ModalLayout, {
    style: showWidenModal ? {
      opacity: 1
    } : {
      opacity: 0
    },
    className: styles['modal-container'],
    onClose: () => onClose(),
    labelledBy: "asset-dialog-title"
  }, /*#__PURE__*/React.createElement(DialogTitle, null), /*#__PURE__*/React.createElement("div", {
    className: styles['search-container']
  }, /*#__PURE__*/React.createElement(WidenSearchBox, {
    onSelect: onSelect,
    filter: filter
  })));
};